<template>
  <div class="header-warpper">
    <div class="header">
      <div class="header-left">
        <img class="logo" :src="logo">
        <p class="name">{{ schoolName }}</p>
      </div>
      <div class="header-right">
        <div class="right-item" @click="handleQuestion">常见问题</div>
        <div class="right-item">
          <el-popover
            placement="bottom-start"
            width="222"
            v-model="visible">
            <div class="popover-content">
              <p class="item-title"><span class="title-icon"></span>信息服务</p>
              <div class="service">
                <p class="service-item" @click="onTechnologicalSearch">科技查新</p>
                <p class="service-item" @click="onRetrievalProof">检索证明</p>
              </div>
              <div class="service">
                <p class="service-item" @click="onPatent">专利信息</p>
              </div>
              <p class="item-title"><span class="title-icon"></span>区块链</p>
              <div class="service">
                <p class="service-item" @click="handleIndex">区块查询</p>
                <p class="service-item" @click="handleIndex">交易查询</p>
              </div>
            </div>
            <div slot="reference" class="menu"><i class="iocn el-icon-menu" /></div>
          </el-popover>
        </div>
        <div class="right-item" @click="handleMessage">
          <el-badge v-if="chatUnReadCount > 0" :value="chatUnReadCount" class="item"><i class="iocn el-icon-chat-line-round" /></el-badge>
          <i v-else class="iocn el-icon-chat-line-round" />
        </div>
        <div class="right-item">
          <el-button class="login-btn" @click="handleLogin">{{$store.state.user.id ? '退出' : '登录'}}</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {logout} from '@/project/service/user'
import tim from '@/framework/utils/chat/tim'
import {findByUser} from '@/project/service/school'

  export default {
    data() {
      return {
        visible: false,
        logo: '',  //机构logo
        schoolName: '',
        authenticationUrl:'',//统一认证地址
        token: localStorage.getItem('USER_H5_WEB_TOKEN'),
      }
    },
    computed: {
      //聊天  有未读消息  小红点
      chatUnReadCount(){
        let unReadCount=0
        this.userList.forEach((item)=>{
          unReadCount+=item.unreadCount
        })
        if(unReadCount===0){
          return unReadCount
        }else{
          return unReadCount
        }
      },
      //聊天的用户列表
      userList(){
        return this.$store.state.userList
      },
    },
    mounted() {
      if(localStorage.getItem('schoolId')) {
        findByUser({id:localStorage.getItem('schoolId')}, res => {
          this.logo = this.$store.state.prefix + res.logo
          this.schoolName = res.name
          this.authenticationUrl = res.authenticationUrl
        })
      }
    },
    methods: {
      onTechnologicalSearch() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.visible = false
          this.$router.push({path: '/technologicalSearch/list'})
        }
      },
      onPatent() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.visible = false
          this.$router.push({path: '/patent/list'})
        }
      },
      onRetrievalProof() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.visible = false
          this.$router.push({path: '/retrievalProof/list'})
        }

      },
      //常见问题
      handleQuestion() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.$router.push({path: '/question/list'})
        }
      },
      //跳转首页
      handleIndex() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.$router.push({path: '/index'})
        }

      },
      //我的消息
      handleMessage() {
        if(this.$route.name === 'login') {
          this.$message.warning('请先登录')
        } else if(!localStorage.getItem('USER_H5_WEB_TOKEN')) {
          this.$confirm('当前操作需要登录，是否进行登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: 'login', params: {id: this.$route.params.id}})
          }).catch(() => {
            return false
          })
        } else {
          this.$router.push({path: '/messageList'})
        }
      },
    //退出登录
      handleLogin() {
        // 退出腾讯云
        if(localStorage.getItem('USER_H5_WEB_TOKEN')) {
          if(this.$store.state.user.id) {
            if(this.$store.state.IMLogin) {
              tim.logout().then((imResponse)=>{
                localStorage.removeItem('currentChatId')
              }).catch((imError)=>{
              })
            }
            logout({}, res=> {
              localStorage.removeItem('h5_web_userCache')
              localStorage.removeItem('USER_H5_WEB_TOKEN')
              this.$store.commit('clear')
              this.$router.push({name: 'login', params: {id: localStorage.getItem('schoolId')}})
            })
          }
        } else {
          if(this.authenticationUrl == null || this.authenticationUrl == ''){
            this.$router.push({name: 'login', params: {id: localStorage.getItem('schoolId')}})
          }else {
            window.location.href = this.authenticationUrl
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.header-warpper {
  min-width: 1280px;
  height: 80px;
  background: url("../../project/assets/images/bg_tab.png") no-repeat;
  background-size: cover;
  //padding: 0 360px;
}
  .header {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
  }
  .header-left {
    display: flex;
    height: 80px;
    align-items: center;
    .logo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 20px;
      vertical-align: center;
    }
    .name {
      font-size: 18px;
    }
  }
  .header-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    flex-basis: 305px;
    .iocn {
      font-size: 20px;
    }
  }
  .right-item {
    cursor: pointer;
  }
  .login-btn {
    width: 60px;
    border-radius: 3px;
    border: 1px solid #FFFFFF;
    background: #4773F1;
    color: #FFFFFF;
  }
  .popover-content {
    padding: 10px 30px 30px;
    .item-title {
      margin: 20px 0 10px;
      .title-icon {
        display: inline-block;
        width: 4px;
        height: 13px;
        background: #4773F0;
        margin-right: 10px;
      }
    }
    .service {
      display: flex;
      justify-content: space-between;
      color: #4773F0;
      margin-bottom:15px;
    }
  }
.service-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout-header.vue